<template>
  <el-button type="danger"
             :disabled="batchid < 1"
             size="mini"
             @click="onSubmit">
    <slot></slot>
  </el-button>
</template>

<script>

export default {
  components: {},
  props: {
    batchid: String,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
    search () {
      return this.searchValue
    },
  },
  methods: {
    onSubmit () {
      this.$confirm('是否确认按批次（已抢单、进行中）收回?', '操作确认', {}).then(() => {
        this.onRequest()
      }).catch(action => {
        console.log('取消按批次收回工单操作')
      })
    },
    onRequest () {
      return request.alert('onBatchWithdraw', {batchid: this.batchid}).then((res) => {
        this.$message({
          showClose: true,
          message: '按批次收回成功,请前往批量任务查看',
          type: 'success',
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/order/components/buttons/OrderOnBatchWithdrawButton.vue